import React, { useState } from 'react';
import { Box, Typography, Button } from '@mui/material';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || '';

export default function FeedbackArticulo({ articuloId }) {
  const [respondido, setRespondido] = useState(false);
  const [enviando, setEnviando] = useState(false);

  async function registrar(util) {
    setEnviando(true);
    try {
      await axios.post(`${API}/api/ayuda/feedback`, { articulo_id: articuloId, util });
    } catch { /* no bloquear si falla */ }
    setRespondido(true);
    setEnviando(false);
  }

  return (
    <Box sx={{
      mt: 5, pt: 3, borderTop: '1px solid rgba(255,255,255,0.08)',
      display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap',
    }}>
      {respondido ? (
        <Typography sx={{ color: '#81c784', fontSize: 14 }}>
          Gracias por tu respuesta.
        </Typography>
      ) : (
        <>
          <Typography sx={{ fontSize: 14, color: '#90a4ae' }}>
            ¿Encontró lo que buscaba?
          </Typography>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button
              size="small"
              variant="outlined"
              disabled={enviando}
              onClick={() => registrar(1)}
              sx={{ color: '#81c784', borderColor: 'rgba(129,199,132,0.3)', fontSize: 13, minWidth: 48,
                '&:hover': { borderColor: '#81c784', bgcolor: 'rgba(129,199,132,0.07)' } }}
            >
              Sí
            </Button>
            <Button
              size="small"
              variant="outlined"
              disabled={enviando}
              onClick={() => registrar(0)}
              sx={{ color: '#ef9a9a', borderColor: 'rgba(239,154,154,0.3)', fontSize: 13, minWidth: 48,
                '&:hover': { borderColor: '#ef9a9a', bgcolor: 'rgba(239,154,154,0.07)' } }}
            >
              No
            </Button>
          </Box>
        </>
      )}
    </Box>
  );
}
